import React from 'react';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { RiskBaseGlobal } from './App/Global';

export const SafeAreaSetter: React.FC = () => {
  RiskBaseGlobal.SafeAreaInsets = useSafeAreaInsets();
  return null;
};
